<div class="report-designer-document" #documentRef [ngStyle]="{'grid-template-rows': data? 'repeat('+Math.ceil(data.pages.length / 6)+', 300px': null}">
  <ng-container *ngIf="data">
    <ng-container *ngFor="let page of data.pages; let index = index; trackBy: trackByPageId">
      <report-designer-page class="report-designer-page report-designer-page-instance"
                            [class.report-designer-page-instance-landscape]="!page.options.isPortrait"
                            [main]="main"
                            [options]="page.options"
                            [widgets]="page.widgets"
                            [page]="page"
                            [footerPageNumber]="index"
                            [document]="this"></report-designer-page>
    </ng-container>
  </ng-container>
</div>
